import React from 'react';
import cn from 'classnames';

const IconList = ({ children, className }) => (
  <ul className={cn('icon-list icon-list-xl', className)}>{children}</ul>
);

export default IconList;
